import ReactReadMoreReadLess from "react-read-more-read-less";

import {
  DesktopContainer,
  Image,
  MobileContainer,
  SVGSprite,
} from "@/components/Atoms";

import { SessionDataI } from "@/containers/ShyftPassBooking/shyftPassMaps";

import styles from "./SessionCard.module.scss";

interface SessionCardProps extends SessionDataI {}

const SessionCard: React.FC<SessionCardProps> = (props) => {
  const {
    time,
    date,
    title,
    description,
    location,
    shortLocation,
    thumbnail,
    centerName,
    googleMapLink,
    setOpenDetailModal,
    shyftPassLogo,
  } = props;

  const backupImageUrl =
    "https://images.unsplash.com/photo-1526506118085-60ce8714f8c5?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80";

  return (
    <div className={styles.sessionCard}>
      <div className={styles.thumbnail}>
        <Image
          src={thumbnail || backupImageUrl}
          alt={title || "workout-session"}
        />
        {shyftPassLogo && (
          <div className={styles.shyftLogo}>
            <Image
              src={
                shyftPassLogo ||
                "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2023-06/Logoshyft_pass_logo_1-cdf5f66dbccb451fb47634a8ce9f22cf.png"
              }
              alt="shyft pass logo"
            />
          </div>
        )}
      </div>
      <div className={styles.sessionData}>
        <div className={styles.dateTime}>
          <div className={styles.sessionTime}>{time}</div>
          <div className={styles.separator}>|</div>
          <div className={styles.sessionDate}>{date}</div>
        </div>
        <div className={styles.title}>{title}</div>
        <DesktopContainer>
          <div className={styles.description}>
            <ReactReadMoreReadLess
              charLimit={110}
              readMoreText={"Read more"}
              readLessText={"Read less"}
            >
              {description}
            </ReactReadMoreReadLess>
          </div>
        </DesktopContainer>
        <MobileContainer>
          <div
            className={styles.description}
            onClick={() => setOpenDetailModal(props)}
          >
            {description.length > 10 ? (
              <>
                {description.substring(0, 50)}
                {"... "}
                <span className={styles.readMore}>Read More</span>
              </>
            ) : (
              description
            )}
          </div>
        </MobileContainer>
        <div className={styles.location}>
          <div className={styles.icon}>
            <SVGSprite icon="icon-location-pin" height="20px" width="10px" />
          </div>
          <a
            className={styles.locationText}
            href={googleMapLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            {shortLocation || `${centerName} - ${location}`}
          </a>
        </div>
      </div>
    </div>
  );
};

export default SessionCard;
